import { render } from "./FlyBasket.vue?vue&type=template&id=3bd74b2d"
import script from "./FlyBasket.vue?vue&type=script&lang=js"
export * from "./FlyBasket.vue?vue&type=script&lang=js"

import exportComponent from "C:\\PHPStormServer\\s_hmel\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__